var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('l-data-table',{attrs:{"title-text":"消息发送历史","headers":_vm.header,"get-data-func":_vm.getMessageLog,"search-text":"搜索收信号码"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }